import '../styles/Header.css';

import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSearch } from "../hooks/SearchContext";
import { useSearchNavigation } from "../hooks/useSearchNavigation";
import { useAuth } from '../hooks/AuthContext';

import { ReactComponent as Logo } from '../assets/logo.svg';
import { ReactComponent as SettingsIcon } from '../assets/settings-icon.svg';
import { ReactComponent as ProfileIcon } from '../assets/profile.svg';

const PATHS_WITHOUT_HEADER = ['/login', '/register'];

const Header = ({
    logo = true, 
    showSearch = false, 
    searchPlaceholder = "Search...",
}) => {
    const { authUser } = useAuth();
    const { query, setQuery } = useSearch();
    const navigate = useNavigate();
    const location = useLocation();
        
    useSearchNavigation();

    const hideHeader = PATHS_WITHOUT_HEADER.includes(location.pathname);

    useEffect(() => {
        if (hideHeader) {
        document.body.style.paddingTop = "0";
        } else {
            document.body.style.paddingTop = "5rem";
        }
    }, [hideHeader]);

    if (hideHeader) {
        return null;
    }

    return (
        <header className="header">
            <div className="header-content">
                {logo && (
                    <Link to="/" className="header-logo">
                        <Logo onClick={() => navigate('/')} />
                    </Link>
                )}
                {showSearch && (
                    <input
                        type="text"
                        placeholder={searchPlaceholder}
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        className="search-bar"
                    />
                )}

                <div className="nav-items">
                    {authUser && (
                        <Link to="/settings" className="settings-icon"><SettingsIcon /></Link>
                    )}
                    <Link to="/account" className="profile-icon"><ProfileIcon /></Link>
                </div>

            </div>
        </header>
    );
};

export default Header;